import PropTypes from 'prop-types'
import React from 'react'

import ComponentSwitcher from 'components/ComponentSwitcher'
import SliderMobile from 'components/SliderMobile'
import { Col } from 'styles/components/layout'

import FaqGutContent from './components/FaqGutContent'
import FaqGutTab from './components/FaqGutTab'
import { RowStyled } from './styles'

/**
 * Faq block with bacterias. You can use it on product pages.
 *
 * @return {Component} Component - FaqGut
 */
export default class FaqGut extends ComponentSwitcher {
  static propTypes = {
    /** Items array for render */
    data: PropTypes.array.isRequired,

    /** Flag to turn on mobile rendering options */
    isMobile: PropTypes.bool,

    /** Background color for tabs */
    theme: PropTypes.oneOf(['white', 'gray']),
  }

  static defaultProps = {
    theme: 'white',
    isMobile: false,
  }

  renderSlider = () => {
    const { data, theme } = this.props

    return (
      <SliderMobile
        swiperArrowsPosition="top"
        className="mb-2 mb-md-4"
        swiperArrowsClassName="mb-2"
      >
        {data.map((item, index) => (
          <div key={index}>
            <FaqGutTab
              isActive={index >= 0}
              theme={theme}
              labelClassName="p-2"
              title={item.title}
            />
            <FaqGutContent activeIndex={index} content={data[index]} />
          </div>
        ))}
      </SliderMobile>
    )
  }

  renderFaqBlock = () => {
    const { data, theme } = this.props
    const { active } = this.state

    return (
      <RowStyled>
        <Col width={{ xs: 5 / 12 }}>
          {data.map((item, index) => (
            <FaqGutTab
              isActive={active === index}
              key={`item.${index}`}
              tabIndex={index}
              activeIndex={active}
              title={item.title}
              onClick={this.handleClick}
              labelClassName="py-3 pr-6 link--inverted"
              theme={theme}
            />
          ))}
        </Col>

        <FaqGutContent activeIndex={active} content={data[active]} />
      </RowStyled>
    )
  }

  render() {
    const { isMobile } = this.props

    return isMobile ? this.renderSlider() : this.renderFaqBlock()
  }
}
